module.exports = __webpack_public_path__ + "assets/e03a24af38727494e81bbc67e05d191b.jpg";